import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { constants, compose } from 'common/helpers'

import contentLoader from 'decorators/contentLoader'

import PlanOptions from './PlanOptions/PlanOptions'
import MonthlyPlanOptions from './MonthlyPlanOptions/MonthlyPlanOptions'
import SelectedPlanSummary from './SelectedPlanSummary/SelectedPlanSummary'
import UpgradeSuccess from './UpgradeSuccess/UpgradeSuccess'

import s from './UpgradeSubscriptionFlow.scss'


class UpgradeSubscriptionFlow extends Component {

  static propTypes = {
    // @contentLoader
    isLoaderVisible: PropTypes.bool,
    showLoader: PropTypes.func,
    hideLoader: PropTypes.func,

    placement: PropTypes.string.isRequired,
    isCloseOnBackClick: PropTypes.bool,
    onClose: PropTypes.func,
    onSuccess: PropTypes.func,
    onFirstClick: PropTypes.func,
    monthPlan: PropTypes.number,
    dataTestId: PropTypes.string,
    onLoaderShow: PropTypes.func,
    onLoaderHide: PropTypes.func,
    onPlansFetched: PropTypes.func,
  }

  isClickedOnce = false

  componentDidMount() {
    const { onPlansFetched } = this.props

    actions.models.upgradeSubscriptionFlow.fetchPlans()
      .then(() => {
        if (typeof onPlansFetched === 'function') {
          onPlansFetched()
        }
      })
      .finally(() => this.hideLoader())
  }

  showLoader = () => {
    const { showLoader, onLoaderShow } = this.props

    if (typeof onLoaderShow === 'function') {
      onLoaderShow()
    }

    showLoader()
  }

  hideLoader = () => {
    const { hideLoader, onLoaderHide } = this.props

    if (typeof onLoaderHide === 'function') {
      onLoaderHide()
    }

    hideLoader()
  }

  onFirstClick = () => {
    const { onFirstClick } = this.props

    if (!this.isClickedOnce && typeof onFirstClick === 'function') {
      onFirstClick()
    }

    this.isClickedOnce = true
  }

  goToStep = (name) => {
    actions.models.upgradeSubscriptionFlow.setCurrStep(name)
  }

  render() {
    const {
      className, email, currStep, placement, monthPlan,
      dataTestId, isLoaderVisible, isCloseOnBackClick,
      onSuccess, onClose,
    } = this.props

    const containerClassName = cx(s.upgradeSubscriptionFlow, className, {
      [s.isLoaderVisible]: isLoaderVisible,
    })

    return (
      <div className={containerClassName} data-testid={dataTestId}>
        <div className={s.content}>
          {
            currStep === constants.upgradeSubscriptionFlowSteps.selectPlan && (
              monthPlan === 1 ? (
                <MonthlyPlanOptions
                  goToStep={this.goToStep}
                  onClose={onClose}
                />
              ) : (
                <PlanOptions
                  goToStep={this.goToStep}
                  onFirstClick={this.onFirstClick}
                />
              )
            )
          }
          {
            currStep === constants.upgradeSubscriptionFlowSteps.selectedPlanSummary && (
              <SelectedPlanSummary
                placement={placement}
                isCloseOnBackClick={isCloseOnBackClick}
                isFetching={isLoaderVisible}
                onSuccess={onSuccess}
                goToStep={this.goToStep}
                hideLoader={this.hideLoader}
                showLoader={this.showLoader}
                onClose={onClose}
              />
            )
          }
          {
            currStep === constants.upgradeSubscriptionFlowSteps.upgradeSuccess && (
              <UpgradeSuccess email={email} onClose={onClose} />
            )
          }
        </div>
      </div>
    )
  }
}

export default compose(
  connect({
    email: 'models.me.email',
    currStep: 'models.upgradeSubscriptionFlow.currStep',
  }),
  contentLoader
)(UpgradeSubscriptionFlow)
